export default __webpack_public_path__ + "static/media/backEnd.01bd6960.png";